// extracted by mini-css-extract-plugin
module.exports = {"small":"768","medium":"1024","large":"1440","xlarge":"1920"};